function createSocket(url){
  if(typeof(WebSocket)==='undefined'){
    this.$message({
      type: 'warning',
      message: '浏览器不支持websocket,请升级最新版本的浏览器！',
      duration:0,
      showClose:true
    });
  }else{
    const nowLocation = window.location;
    const protocol = nowLocation.protocol;
    const host = nowLocation.host;
    const webSocketApiUrl =  ((protocol.startsWith('https')) ? 'wss://' : 'ws://') + host;
    const wsUrl =webSocketApiUrl+ process.env.VUE_APP_WEBSOCKET_API + `${url}`;
    let ws=new WebSocket(wsUrl);
    return ws
  }
}
export default createSocket